import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { useCurrentSubscriptionExpired, useSubscriptionExpiringWithinMonth } from "@dashboard/workspaces/api/helpers";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

const linkComponents = {
    // Deliberately not named "link": html-parse-stringify treats <link> as a void element,
    // so Trans would drop the label out of the anchor and leave it unclickable.
    subscriptionLink: <a target="_blank" href="https://emteria.com/p/subscription" rel="noopener noreferrer" />,
};

type SubscriptionAlertProps = {
    style?: React.CSSProperties;
};

export const SubscriptionAlert = (props: SubscriptionAlertProps) => {
    const { t } = useTranslation(["pages"]);
    const isExpired = useCurrentSubscriptionExpired();
    const isExpiringWithinMonth = useSubscriptionExpiringWithinMonth();

    if (isExpired) {
        return (
            <CustomAlert
                title={t("pages:workspacePage.section.subscriptionAlert.expiredTitle")}
                severity="error"
                style={props.style}
            >
                <Trans ns="pages" i18nKey="workspacePage.section.subscriptionAlert.expired" components={linkComponents} />
            </CustomAlert>
        );
    }

    if (isExpiringWithinMonth) {
        return (
            <CustomAlert
                title={t("pages:workspacePage.section.subscriptionAlert.expiringTitle")}
                severity="warning"
                style={props.style}
            >
                <Trans ns="pages" i18nKey="workspacePage.section.subscriptionAlert.expiring" components={linkComponents} />
            </CustomAlert>
        );
    }

    return null;
};
